export enum EDataHookStatusType {
  SUCCESS = 0,
  FAILURE = 1
}
